module.exports = __webpack_public_path__ + "img/vertical_3_5_8011.8963af12.png";